<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="学生姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name']" placeholder="请输入学生姓名"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="userInfo().username === 'admin'">
            <a-form-item label="消息推送设置" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <j-multi-select-tag
                v-model="model.smsTemplateCode"
                dictCode="sys_sms_template,template_name,template_code"
                placeholder="请选择消息推送模版"
              ></j-multi-select-tag>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="所属班级" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                placeholder="请输入所属班级"
                v-model="model.classId"
                dict="school_class,name,id,delete_flag=0"
                :async="false"
                style="width: 100%"
              ></j-search-select-tag>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="关爱等级" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                v-model="model.careList"
                dictCode="care_list"
                placeholder="请选择关爱等级"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :span="24" v-if="userInfo().username === 'admin'">
            <a-form-item label="心情灯设备号" :labelCol="labelCol" :wrapperCol="wrapperCol" >
              <a-input v-decorator="['moodLampId']" placeholder="请输入心情灯设备号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="userInfo().username === 'admin'">
            <a-form-item label="心情灯推送模型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                v-model="model.lampSendModel"
                dictCode="lamp_send_model"
                placeholder="请选择心情灯状态"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="学生图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-image-upload
                v-decorator="['pic']"
                :bizPath="'headImg/' + tenantId"
              ></j-image-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>
import { httpAction } from '@/api/manage'
import pick from 'lodash.pick'
import JFormContainer from '@/components/jeecg/JFormContainer'
import JDate from '@/components/jeecg/JDate'
import JImageUpload from '@/components/jeecg/JImageUpload'
import JMultiSelectTag from '@/components/dict/JMultiSelectTag'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import { TENANT_ID } from '@/store/mutation-types'
import Vue from 'vue'
import {mapGetters} from "vuex";

export default {
  name: 'StudentInfoForm',
  components: {
    JFormContainer,
    JDate,
    JImageUpload,
    JMultiSelectTag,
    JSearchSelectTag,
  },

  data() {
    return {
      form: this.$form.createForm(this),
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      tenantId: Number(Vue.ls.get(TENANT_ID)),
      url: {
        add: '/aigoes/studentInfo/add',
        edit: '/aigoes/studentInfo/edit',
        queryById: '/aigoes/studentInfo/queryById',
      },
      selectValue: '',
      asyncSelectValue: '',
      dictOptions: [
        {
          text: '是',
          value: '1',
        },
        {
          text: '否',
          value: '0',
        },
      ],
    }
  },
  created() {},
  methods: {
    ...mapGetters(['userInfo']),
    add() {
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      console.log('学生数据', this.model)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'name',
            'sex',
            'careList',
            'studentNo',
            'parentName',
            'parentNameId',
            'parentRelation',
            'parentPhone',
            'classId',
            'inOutRemind',
            'eventRemind',
            'pic',
            'smsTemplateCode',
            'callback',
            'moodLampId',
            'moodLampStatus',
            'createBy',
            'createTime',
            'updateBy',
            'updateTime'
          )
        )
      })
    },
    submitForm() {
      const that = this
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          console.log(this.model.id)
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          let formData = Object.assign(this.model, values)
          formData.schoolClass = {}
          console.log('表单提交数据', formData)
          formData.schoolClass = {}
          // return
          httpAction(httpurl, formData, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
  },
}
</script>
